<template>
  <div class="container my-5 d-flex flex-column">
    <h1>Conditions Générales de Vente</h1>

    <!-- Section Généralités -->
    <section class="text-start my-4">
      <h2 class="text-warning">Généralités</h2>
      <p>
        Attendu que les présentes conditions générales trouvent à s’appliquer
        dans le cadre de relations contractuelles entre la société VMCT SRL et
        ses clients à l’exclusion de tout autre.
      </p>
      <p>
        Toute dérogation aux présentes conditions doit faire l’objet d’un accord
        écrit au préalable.
      </p>
      <p>
        Les conditions générales seront également applicables pour toute
        commande supplémentaire ou modification de commande pour autant que
        celles-ci se fassent par écrit.
      </p>
      <p>
        Le signataire déclare avoir pris connaissance des conditions générales
        reprises ci-dessous et engage(nt) leur responsabilité quant au paiement
        de la facture.
      </p>
      <p>
        En cas de nullité d’une des clauses des présentes conditions générales ;
        les autres clauses restent valables.
      </p>
    </section>

    <!-- Section Les Containers -->
    <section class="text-start my-4">
      <h2 class="text-warning">Les Containers</h2>
      <p>
        Le container a la capacité demandée par le client. En aucun cas le bord
        de ce container ne peut être dépassé. Le contenu doit être réparti de
        manière équilibrée.
      </p>
      <p>En cas de non-respect, le client devra :</p>
      <ul>
        <li>
          Soit en décharger le surplus et un déplacement inutile lui sera
          facturé au prix de 121,00€ TVAC ;
        </li>
        <li>
          Soit payer un supplément calculé sur la base de 60,5€ TVAC/m<sup
            >3</sup
          >
          supplémentaire.
        </li>
      </ul>
      <p>
        Le container mis à disposition du client est un bien de location et
        reste donc la propriété de la SRL VMCT. Le client veillera à prendre
        toutes les mesures nécessaires afin de préserver le droit de propriété à
        l’encontre de tiers.
      </p>
      <p>
        Le container est déposé au client en parfait état. Toute détérioration
        ou salissure sera facturée au client.
      </p>
      <p>
        Le container peut rester 3 à 4 jours sans supplément. À partir du 5<sup
          >ème</sup
        >
        jour, un supplément de 2,50€ HTVA par jour sera facturé.
      </p>
    </section>

    <!-- Section Prix et Paiement -->
    <section class="text-start my-4">
      <h2 class="text-warning">Prix et Paiement</h2>
      <p>Les prix indiqués sont TVAC.</p>
      <p>Les prix sont ceux mentionnés dans l’offre et/ou la commande.</p>
      <p>
        Les prix de l’offre et/ou la commande sont basés sur une prestation
        effectuée durant l’horaire normal de travail en vigueur chez VMCT SRL.
      </p>
      <p>
        Lors des travaux forfaitaires, toute modification au travail non prévue
        dans l’offre sera facturée en régie au tarif de 60,50€ TVAC/h et par
        personne.
      </p>
      <p>
        En cas d’acceptation du devis, le client est tenu de respecter ses
        engagements.
      </p>
      <p>
        Les factures seront considérées comme acceptées par le client, à défaut
        de contestation par lettre recommandée endéans les huit jours de la date
        d’envoi. Passé ce délai, aucune réclamation, quelle qu’elle soit, ne
        pourra être prise en considération.
      </p>
      <p>
        En cas de non-paiement, le contenu reste la propriété du client et une
        indemnisation forfaitaire lui sera facturée de l’ordre de 100€ par jour
        de mise à disposition à dater du dépôt du container.
      </p>
      <p>
        Toute facture demeurant impayée à son échéance sera de plein droit, et
        sans mise en demeure préalable, productrice d’un intérêt de retard au
        taux de 10%, majoré de 12% du montant total de la facture, à titre de
        clause pénale avec un minimum de 40€.
      </p>
    </section>

    <!-- Bouton retour à l'accueil -->
    <router-link to="/" class="btn btn-primary btn-lg mt-4 ms-auto">
      <i class="fa fa-home"></i> Retour à l'accueil
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ConditionsView'
}
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: auto;
  text-align: left;
}

h1 {
  color: #f0b800;
  /* Couleur du titre principal */
}

.text-warning {
  color: #f0b800;
}

p {
  margin: 1rem 0;
  font-size: 1rem;
  line-height: 1.5;
}

ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
  list-style-type: disc;
}

li {
  margin: 0.5rem 0;
  font-size: 1rem;
}
</style>
